import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { Branding, HelpButton, SupportButton, MeControl } from './components';

const getStyles = () => ({
  container: {
    height: '60px',
    backgroundColor: '#ebebeb',
    paddingLeft: '12px',
    paddingRight: '12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
  },
});

export const NewSignupHeader = ({
  userName,
  signOutUrl,
  customizedSignOut,
  showSupportButton,
  showMeControl,
  onSupportButtonClick,
}) => {
  const classes = useDefaultStyles(getStyles);

  return (
    <div role="banner" className={classNames(classes.container, 'new-signup-header')}>
      <Branding />
      <div className={classNames(classes.toolbar, 'toolbar-part')}>
        <HelpButton />
        {showSupportButton && <SupportButton onClick={onSupportButtonClick} />}
        {showMeControl && <MeControl
          userName={userName}
          signOutUrl={signOutUrl}
          customizedSignOut={customizedSignOut}
        />}
      </div>
    </div>
  );
};

NewSignupHeader.propTypes = {
  userName: PropTypes.string,
  signOutUrl: PropTypes.string,
  customizedSignOut: PropTypes.func,
  showSupportButton: PropTypes.bool,
  showMeControl: PropTypes.bool,
  onSupportButtonClick: PropTypes.func,
};

NewSignupHeader.defaultProps = {
  userName: '',
  customizedSignOut: undefined,
  signOutUrl: '#',
  showSupportButton: false,
  showMeControl: true,
  onSupportButtonClick: undefined,
};
